module.exports = __webpack_public_path__ + "img/cloro-jasmim-mobile.82d67aa3.png";